<template>
  <div id="setOverview">
    <div class="row">
      <div class="col-12">
        <!-- Price drop and model discount -->
        <div
          v-if="isCampaignPriceDrop || set.isModelDiscount"
          class="action-box"
        >
          <div class="row">
            <div class="col-6 col-sm-4 text-start total-price">
              <template>
                {{ $t("Set.Overview.totalPrice") }}
              </template>
              <p class="price original" :class="country">
                <span class="price-original">
                  <template v-if="set.isModelDiscount">
                    {{ $n(set.totalPriceOriginal, "currency") }}
                  </template>
                  <template v-else>
                    {{
                      $n(
                        Math.floor(set.totalPriceWeddingbands * 1.08) +
                          set.totalPriceJewellery +
                          set.totalPriceEngraving,
                        "currency"
                      )
                    }}
                  </template>
                </span>
              </p>
            </div>
            <div class="col-6 col-sm-4 text-start total-price">
              <template>
                {{ $t("Set.Overview.specialPrice") }}
              </template>
              <p class="price discount" :class="country">
                <span class="price-discount">
                  {{ $n(set.totalPrice, "currency") }}
                </span>
              </p>
            </div>
            <div class="d-none col-4 text-end total-price-items">
              <template v-for="(item, index) in set.items">
                <div :key="index" :title="getPriceTitle(index)">
                  <label>
                    <template v-if="!isBreakpointXS">
                      {{ $t("Common.items") }} {{ index + 1 }}
                    </template>
                    <template v-else>
                      {{ $t("Common.itemsShort") }} {{ index + 1 }}
                    </template>
                    <CopyIcon
                      :textToCopy="item.itemnumber"
                      iconWidth="2"
                      feedback="icon"
                    />
                  </label>
                  <span class="text-end" style="cursor: pointer">
                    {{ $n(item.price.total, "currency") }}
                  </span>
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- Default -->
        <div v-else class="action-box">
          <div class="row">
            <div
              class="col-6 text-start total-price"
              :class="{ 'is-campaign': isCampaignWeddingRings }"
            >
              <template
                v-if="!set.totalDiscount || parseFloat(set.totalDiscount) === 0"
              >
                {{ $t("Set.Overview.totalPrice") }}
              </template>
              <template v-else>
                {{ $t("Set.Overview.specialPrice") }}
              </template>
              <p
                class="price"
                :class="country"
                v-if="!set.totalDiscount || parseFloat(set.totalDiscount) === 0"
              >
                <template>{{ $n(set.totalPrice, "currency") }}</template>
              </p>
              <p class="price discount" :class="country" v-else>
                <span class="price-discount">
                  {{ $n(set.totalPrice, "currency") }}
                </span>
              </p>
            </div>
            <div
              class="col-6 text-start total-price-items text-end no-flex"
              :class="{ 'is-campaign': isCampaignWeddingRings }"
            >
              <template v-for="(item, index) in set.items">
                <div :key="index" :title="getPriceTitle(index)">
                  <span
                    class="item-price-box text-end no-flex"
                    style="cursor: pointer"
                  >
                    <CopyIcon
                      :textToCopy="item.itemnumber"
                      iconWidth="2"
                      feedback="icon"
                    />
                    <template v-if="!isBreakpointXS">
                      <span class="item-price-short"
                        >{{ $t("Common.items") }} {{ index + 1 }}:</span
                      >
                    </template>
                    <template v-else>
                      <span class="item-price-short"
                        >{{ $t("Common.itemsShort") }} {{ index + 1 }}:</span
                      >
                    </template>
                    <span class="item-price-amount">{{
                      $n(item.price.total, "currency")
                    }}</span>
                  </span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template>
      <div id="FirstCtaBox">
        <div class="row" v-if="isShopLoginActive">
          <div class="col-12">
            <a class="btn btn-primary btn-block" @click="addToShoppingCart">
              {{ $t("Set.Overview.button.shopOrder") }}
            </a>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-6 text-center col-cta-left">
            <a class="btn btn-block btn-secondary" @click="addToShoppingCart">
              {{ $t("Set.Overview.button.shoppingcart") }}
            </a>
            <!--
            <a
              v-if="isGetLocationPossible"
              class="btn-link btn-block text-link"
              ref="linkGetNextShop"
              data-loader="no"
              :text-btn="
                isLessThan375
                  ? $t('Set.Overview.button.maps.nextShopMobile')
                  : $t('Set.Overview.button.maps.nextShop')
              "
              :text-alert="$t('Set.Overview.button.maps.alert')"
              @click="getNextShop"
              style="margin-top: 1rem"
            >
              <template v-if="!isLessThan375">
                {{ $t("Set.Overview.button.maps.nextShop") }}
              </template>
              <template v-else>
                {{ $t("Set.Overview.button.maps.nextShopMobile") }}
              </template>
            </a>
            -->
          </div>
          <div class="col-6 text-center col-cta-right">
            <a class="btn btn-block btn-primary" :href="appointmentUrl">
              {{ $t("Set.Overview.button.appointment") }}
            </a>
          </div>
          <div class="col-12" v-if="isRequestServicePossible">
            <button
              class="btn btn-link"
              @click="requestService"
              style="margin-top: 2rem"
            >
              {{ $t("Set.Overview.button.requestService") }}
            </button>
          </div>
        </div>
      </div>
    </template>
    <div id="SecondCtaBox">
      <div class="row first-row">
        <div class="col-12 col-sm-6 col-md-12 col-lg-6">
          <button class="btn btn-link" @click="toggleWishlist">
            {{ $t("Wishlist.button.open") }}
          </button>
        </div>
        <div class="col-12 col-sm-6 col-md-12 col-lg-6">
          <button
            v-if="$parent['showItemDetails'] === false"
            class="btn btn-link"
            @click="
              $parent['showItemDetails'] = true;
              $parent['setShowSideMenu'](true);
            "
          >
            {{ $t("Common.itemDetailsShow") }}
          </button>
          <button
            v-else
            class="btn btn-link"
            @click="
              $parent['showItemDetails'] = false;
              $parent['setShowSideMenu'](false);
            "
          >
            {{ $t("Common.itemDetailsHide") }}
          </button>
        </div>
        <div class="col-12 col-sm-6 col-md-12 col-lg-6">
          <button class="btn btn-link" @click="restoreSet">
            {{ $t("Set.Overview.restoreSet.button") }}
          </button>
        </div>
        <div
          class="col-12 col-sm-6 col-md-12 col-lg-6"
          v-if="isShopLoginActive"
        >
          <button class="btn btn-link new-customer" @click="newCustomer">
            {{ $t("Common.newCustomer.button") }}
          </button>
        </div>
      </div>
      <div class="row last-row">
        <div v-if="set.setId !== ''" :class="isQrCode() ? 'col-6' : 'col-12'">
          <br />
          <div class="row">
            <div class="col-12">
              <a
                :href="
                  imageHost +
                  '/sets/600/' +
                  $parent.$parent['correctSetId'](set.setId) +
                  '.jpg'
                "
                target="_blank"
                class="btn btn-link set-image-link"
              >
                {{ $t("Set.Overview.setId") }}:
                {{ $parent.$parent["correctSetId"](set.setId).toUpperCase() }}
              </a>
              <CopyIcon
                :textToCopy="
                  $parent.$parent['correctSetId'](set.setId).toUpperCase()
                "
                iconWidth="3.5"
                feedback="icon"
              />
            </div>
          </div>
        </div>
        <div :class="set.setId !== '' ? 'col-6' : 'col-12'" v-if="isQrCode()">
          <br />
          <p class="qrcode-box">
            <QrCode :set="set" />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SetData from "@/vuex/SetData";
import Notification from "@/assets/Helper/Notification";
import Logger from "@/assets/Helper/Logger";
import Wishlist from "@/assets/Wishlist";
import DAOWishlist from "../../../public/js/DAO/Wishlist";
import ShoppingCart from "@/assets/ShoppingCart";
import Location from "@/assets/Location";
import Config from "@/vuex/Config";
import Status from "@/vuex/Status";
import MediaQuery from "@/assets/Helper/MediaQuery";
import CopyIcon from "./../Icons/Copy";
import QrCode from "@/components/Icons/QrCode.vue";

export default {
  name: "SetOverview",
  props: ["set"],
  components: {
    QrCode,
    CopyIcon,
  },
  data() {
    return {
      isOnWishlist: false,
      appUrl: Config.getters.getAppUrl,
      campaigns:
        typeof window.conf2020AppConfig.campaigns === "object"
          ? window.conf2020AppConfig.campaigns
          : { weddingbands: "no", jewellery: "no", priceDrop: "no" },
      setItems: SetData.getters.getSet,
      imageHost: process.env.VUE_APP_IMAGE_HOST,
      language: Config.state.language,
      country: Config.state.country,
    };
  },
  updated() {
    this.handleAfterIsPopState();
    this.$root.$emit("updateQrCode");
  },
  mounted() {
    this.handleAfterIsPopState();

    this.$root.$on("setBtnWishlistOn", () => {
      this.isOnWishlist = true;
    });
    this.$root.$on("setBtnWishlistOff", () => {
      this.isOnWishlist = false;
    });
    this.$root.$on("checkWishlistButton", () => {
      this.checkWishlist();
    });
    this.$ga.page("/set/overview");
  },
  beforeDestroy() {
    this.$root.$off("setBtnWishlistOn");
    this.$root.$off("setBtnWishlistOff");
    this.$root.$off("checkWishlistButton");
  },
  computed: {
    isShopLoginActive: function () {
      return Config.getters.isShopLoginActive;
    },
    isGetLocationPossible: function () {
      return Location.isGetLocationPossible();
    },
    isRequestServicePossible: function () {
      return ShoppingCart.isRequestServicePossible();
    },
    appointmentUrl: function () {
      return typeof window.conf2020AppConfig.locationsUrl === "string" &&
        window.conf2020AppConfig.locationsUrl !== ""
        ? window.conf2020AppConfig.locationsUrl
        : "/";
    },
    isCampaignWeddingRings: function () {
      if (
        this.campaigns.weddingbands === "yes" &&
        this.$parent.isCurrentItemWeddingRing()
      ) {
        return true;
      }
      return false;
    },
    isCampaignPriceDrop: function () {
      return (
        this.campaigns.priceDrop === "yes" && !this.$parent.onlyJewellery()
      );
    },
    isLessThan375: function () {
      return MediaQuery.isLessThan375();
    },
    isBreakpointXS: function () {
      return MediaQuery.isBreakpointXS();
    },
  },
  watch: {
    set: {
      handler: function () {
        this.checkWishlist();
      },
      deep: true,
    },
  },
  methods: {
    isQrCode: function () {
      return (
        typeof window.conf2020AppConfig["qrCodeUrl"] === "string" &&
        window.conf2020AppConfig["qrCodeUrl"] !== ""
      );
    },
    getPriceTitle: function (currentItemId) {
      let item = this.set.items[currentItemId];

      let title = "";

      if (item.description.jewelleryType !== 5) {
        if (
          (!item.price.discount || item.price.discount == 0) &&
          !this.$parent["isDiamondGroupPline"](
            parseInt(item.description["plineId"])
          ) &&
          !this.$parent["isTotalPriceProduct"](
            parseInt(item.description["brandId"]),
            parseInt(item.description["plineId"])
          )
        ) {
          title =
            this.$t("Common.jewelleryType." + item.description.jewelleryType) +
            ": " +
            this.$n(item.price.ring, "currency") +
            "\n";

          if (item.price.stone > 0) {
            title +=
              this.$t("Set.Overview.item.price.stone") +
              ": " +
              this.$n(item.price.stone, "currency") +
              "\n";
          }
        } else {
          title =
            this.$t("Common.jewelleryType." + item.description.jewelleryType) +
            ": " +
            this.$n(item.price.ring + item.price.stone, "currency") +
            "\n";
        }
        title +=
          this.$t("Set.Overview.item.price.engraving") +
          ": " +
          this.$n(item.price.engraving, "currency") +
          "\n";
      }

      if (
        (!item.price.discount || item.price.discount == 0) &&
        !this.$parent["isDiamondGroupPline"](
          parseInt(item.description["plineId"])
        ) &&
        !this.$parent["isTotalPriceProduct"](
          parseInt(item.description["brandId"]),
          parseInt(item.description["plineId"])
        )
      ) {
        title +=
          this.$t("Set.Overview.item.price.total") +
          ": " +
          this.$n(item.price.total + item.price.engraving, "currency");
      } else {
        title +=
          this.$t("Set.Overview.item.price.special") +
          ": " +
          this.$n(item.price.total + item.price.engraving, "currency");
      }

      return title;
    },
    handleAfterIsPopState: function () {
      if (
        history &&
        typeof history.state == "object" &&
        history.state.ispopstate === true
      ) {
        history.state.ispopstate = false;

        this.$parent["showItemDetails"] = false;

        if (this.set.items.length > 1) {
          setTimeout(() => {
            this.switchCurrentItem("overview");
          });
        }
        this.$root.$emit("updateViewer");
      }
    },
    addItem: function () {
      this.switchCurrentItem("all");
      this.$parent["showItemDetails"] = false;
    },
    switchCurrentItem: function (newCurrentItem) {
      this.$parent.$parent["setCurrentItem"](newCurrentItem);
      this.$root.$emit("setOverview");

      Config.dispatch("setVisualMode", "show").then(() => {
        Config.dispatch("setCurrentVarType", "");
      });
    },
    restoreSet: function () {
      this.$parent.$parent["reset3d"]();

      let itemnumbersStart = SetData.getters.getItemnumbersStart;

      if (typeof itemnumbersStart == "object" && itemnumbersStart.length > 0) {
        Status.dispatch("setLoading", true);

        /* Keep ring size and set items in whishlist */
        let setData = SetData.getters.getSet;
        if (typeof setData == "object" && setData.items.length > 0) {
          let diffNumberItems = setData.items.length - itemnumbersStart.length;
          let dropItemStart = setData.items.length - diffNumberItems;

          if (
            diffNumberItems > 0 &&
            diffNumberItems >= itemnumbersStart.length
          ) {
            for (
              let itemKey = setData.items.length - 1;
              itemKey >= dropItemStart;
              itemKey--
            ) {
              SetData.dispatch("dropItem", itemKey);
            }
          }

          for (let i in itemnumbersStart) {
            let tmpItemnumber = itemnumbersStart[i].split(":");
            if (tmpItemnumber[0]) {
              if (!setData.items[i]) {
                SetData.dispatch("addItem", itemnumbersStart[i]).then(() => {
                  if (i == itemnumbersStart.length - 1) {
                    window.location.href =
                      Config.getters.getIntegrationUrlPrafix +
                      "/" +
                      itemnumbersStart.join("/") +
                      "/";
                  }
                });
              } else {
                let size = !isNaN(setData.items[i].size)
                  ? setData.items[i].size
                  : 54;
                itemnumbersStart[i] = tmpItemnumber[0] + ":" + size;

                SetData.dispatch("setItem", {
                  key: i,
                  id: tmpItemnumber[0],
                }).then(() => {
                  if (i == itemnumbersStart.length - 1) {
                    window.location.href =
                      Config.getters.getIntegrationUrlPrafix +
                      "/" +
                      itemnumbersStart.join("/") +
                      "/";
                  }
                });
              }
            }
          }
        }

        Logger.debug("Restore Itemnumbers");
      } else {
        Notification.create(this.$t("Set.Overview.restoreSet.alert"));
      }
    },
    newCustomer: function () {
      if (confirm(this.$t("Common.newCustomer.alert"))) {
        DAOWishlist.getAll("configure")
          .then((configurationList) => {
            if (
              typeof configurationList == "object" &&
              configurationList.length > 0
            ) {
              for (let i in configurationList) {
                DAOWishlist.drop("configure", configurationList[i].primaryKey);
              }
            }
          })
          .then(() => {
            window.location.href = Config.getters.getIntegrationUrlPrafix + "/";
          });
      }
    },
    checkWishlist: function () {
      let wishlistData = SetData.getters.getWishlistItemData;
      DAOWishlist.getItemId("wishlist", wishlistData).then((wishlistItemId) => {
        this.isOnWishlist = !(wishlistItemId === false);
      });
    },
    toggleToWishlist: function () {
      let wishlistData = SetData.getters.getWishlistItemData;

      Wishlist.toggleWishlist(wishlistData).then((result) => {
        this.isOnWishlist = result;

        if (result == true) {
          this.$root.$emit("setHeartWishlistOn");
        } else {
          this.$root.$emit("setHeartWishlistOff");
        }
      });
    },
    addToShoppingCart: function () {
      ShoppingCart.add();
    },
    requestService: function () {
      ShoppingCart.requestService();
    },
    getNextShop: function () {
      Location.getNextShop(this.$refs["linkGetNextShop"]);
    },
    toggleWishlist: function () {
      this.$root.$emit("wishlist");
      Config.dispatch("setVisualMode", "wishlist");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  #setOverview {
    background-color: $white;
  }

  .set-image-link {
    display: inline;
    text-decoration: none;
    padding-left: 0;
    padding-right: 0;
  }

  .item-price-box {
    display: inline-flex;
    width: 18rem;
  }

  .item-price-short {
    display: inline-block;
    width: calc(50% - 2.5rem);
    text-align: left;
    padding-right: 0.1rem;
  }

  .item-price-amount {
    font-weight: bold;
    display: inline-block;
    width: calc(50% - 1.5rem);
    text-align: right;
  }

  .action-box {
    position: relative;
    background-color: $white;
    margin-top: 3rem;
    padding: 2rem;
    font-size: 1.6rem;

    p {
      margin: 0;
    }

    .price {
      font-size: 3.2rem;
    }

    .price-discount,
    .price-original {
      font-size: 1em;
      display: inline-block;
    }

    .price-discount {
      color: $pink;
    }

    .price-original {
      margin-right: 1rem;
      text-decoration: line-through;
      color: #b5b5b5;
    }
  }

  #FirstCtaBox {
    padding: 2rem;

    .text-link {
      text-decoration: underline;
    }

    @media (max-width: 767px) {
      button:nth-child(odd) {
        margin-top: 1.2rem;
      }
    }
  }

  #SecondCtaBox {
    display: none;
    padding: 0 2rem 2rem 2rem;

    .first-row {
      border-top: 0.1rem solid #ededed;
      margin-top: 1rem;
      padding-top: 2rem;
    }

    .last-row {
      padding-top: 3rem;
    }

    @media (min-width: 1200px) {
      display: block;
    }
  }

  #FirstCtaBox,
  #SecondCtaBox {
    button {
      padding-left: 0;
      padding-right: 0;
    }
  }

  p.qrcode-box {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
